exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: OpenSans-Regular;\n  src: url(" + require("../fonts/OpenSans-Regular.ttf") + ");\n}\n@font-face {\n  font-family: OpenSans-Semibold;\n  src: url(" + require("../fonts/OpenSans-Semibold.ttf") + ");\n}\n@font-face {\n  font-family: OpenSans-Bold;\n  src: url(" + require("../fonts/OpenSans-Bold.ttf") + ");\n}\n@font-face {\n  font-family: Roboto-Bold;\n  src: url(" + require("../fonts/Roboto-Bold.ttf") + ");\n}\n@font-face {\n  font-family: Roboto-Light;\n  src: url(" + require("../fonts/Roboto-Light.ttf") + ");\n}\n@font-face {\n  font-family: Roboto-Medium;\n  src: url(" + require("../fonts/Roboto-Medium.ttf") + ");\n}\n@font-face {\n  font-family: Roboto-Regular;\n  src: url(" + require("../fonts/Roboto-Regular.ttf") + ");\n}\n@font-face {\n  font-family: Roboto-Thin;\n  src: url(" + require("../fonts/Roboto-Thin.ttf") + ");\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/resources/styles/fonts.less
// module id = 639
// module chunks = 0